import PropTypes from "prop-types";
import React from "react";
import "./style.scss";

export default function CarDeliveryTemplate({ fields, children }) {
  const { backgroundImage } = fields;
  return (
    <div className="car-delivery-template grid">
      <div className="car-delivery-template-image">
        <img {...{ ...backgroundImage?.value, url: backgroundImage?.value?.src }} />
      </div>
      <div className="car-delivery-template-left">{children}</div>
    </div>
  );
}

CarDeliveryTemplate.propTypes = {
  backgroundImage: PropTypes.shape({ src: PropTypes.string }),
  children: PropTypes.node
};
